export const removeSignatureFields = (html: string) => {
  const searchTexts = ['Local e Data', 'Assinatura do Segurado'];

  const splitedHtml = html.split('<p>');

  const modifiedHtml = splitedHtml.filter(splitHtml => !searchTexts.some(string => splitHtml.includes(string)));

  return modifiedHtml.join('<p>').replaceAll('<br />', '');
};
